import { render, staticRenderFns } from "./FolderWorkflowAnwserQuestionsDialog.vue?vue&type=template&id=316d1bf4&scoped=true"
import script from "./FolderWorkflowAnwserQuestionsDialog.vue?vue&type=script&lang=js"
export * from "./FolderWorkflowAnwserQuestionsDialog.vue?vue&type=script&lang=js"
import style0 from "./FolderWorkflowAnwserQuestionsDialog.vue?vue&type=style&index=0&id=316d1bf4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316d1bf4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VProgressLinear,VTooltip})
